export const Icontypes = {
  recurrentes: "recurrentes",
}
